import React, { Component } from 'react';
import './Contact.scss';

export default class Contact extends Component {
  render() {
    return (
      <div className={"Contact"}>
        <h1>Contact</h1>
      </div>
    )
  }
}
